import { FormattedNotificationItemType, INotificationFormatter } from '@/lib/formatter/notification-formatter'
import { NotificationType } from '@/types/notification'

/**
 * PRODUCTS_EXCEL_IMPORT notification formatter
 * Extends notification with a link to the export detail page
 */
export default class ProductsExcelImportFormatter implements INotificationFormatter {
  format(notification: NotificationType): FormattedNotificationItemType {
    const id = notification.payload?.id

    const additionalParams: Array<{
      key: string
      values?: Record<string, any>
    }> = []

    if (notification.payload?.createdTotal !== undefined && notification.payload?.createdTotal !== null) {
      additionalParams.push({
        key: 'created_items_count',
        values: { count: notification.payload.createdTotal }
      })
    }

    if (notification.payload?.updatedTotal !== undefined && notification.payload?.updatedTotal !== null) {
      additionalParams.push({
        key: 'updated_items_count',
        values: { count: notification.payload.updatedTotal }
      })
    }

    if (notification.payload?.failedTotal !== undefined && notification.payload?.failedTotal !== null) {
      additionalParams.push({
        key: 'failed_items_count',
        values: { count: notification.payload.failedTotal }
      })
    }

    if (notification.payload?.total !== undefined && notification.payload?.total !== null) {
      additionalParams.push({
        key: 'total_processed_products',
        values: { count: notification.payload.total }
      })
    }

    if (notification.payload?.message) {
      additionalParams.push({
        key: notification.payload.message
      })
    }

    return {
      ...notification,
      additionalParams,
      link: id ? `/products/import/excel/${id}` : undefined
    }
  }
}
